import axios, { AxiosError, AxiosRequestConfig } from "axios";
import { useCallback, useEffect, useState } from "react";
import ApiConstants from "../../../api-constants";
import { GeneralScore } from "../../../Types/GeneralScore";
import { customParamsSerializer } from "./useGolfCourseHoleDetails";

// axios.defaults.paramsSerializer = customParamsSerializer;

axios.interceptors.request.use(
  (config: any) => {
    if (config.headers) {
      config.headers = Object.fromEntries(
        Object.entries(config.headers).filter(
          ([, value]) => value !== null && value !== undefined && value !== ""
        )
      );
    }
    return config;
  },
  (error) => {
    // Handle request error
    return Promise.reject(error);
  }
);
function useGolfGeneralScores(roundIds?: string[]) {
  const [golfGeneralScores, setGolfGeneralScores] = useState<GeneralScore[]>(
    []
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<AxiosError | null>(null);

  const getGolfGeneralScores = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const res = await axios.get(ApiConstants.parseGolfGeneralScores, {
        headers: {
          // Authorization: ApiConstants.authToken,
          "X-Parse-Application-Id": ApiConstants.parseApplicationId,
          "X-Parse-Client-Key": ApiConstants.parseClientKey,
          "X-Parse-Master-Key": ApiConstants.parseMasterKey,
        },
        params: {
          limit: 3000,
          include: "holeId",
          count: 1,
          where: {
            round_id: {
              $in: roundIds,
            },
          },
        },
        paramsSerializer: customParamsSerializer,
      });
      if (res.status === 200) {
        setGolfGeneralScores(res.data.results);
      } else {
        throw new AxiosError(`Unexpected response status: ${res.status}`);
      }
    } catch (err) {
      setError(err as AxiosError);
      console.error("Error fetching golf course hole details:", err);
    } finally {
      setIsLoading(false);
    }
  }, [roundIds]);

  useEffect(() => {
    if (roundIds?.length) {
      getGolfGeneralScores();
    }
  }, [getGolfGeneralScores, roundIds]);

  return { golfGeneralScores, isLoading, error };
}

export default useGolfGeneralScores;
